export default {
  icon: ' mdi-tag',
  text: 'Marcas',
  permissions: [
    { name: 'brandsIndex', text: 'Visualizar Marcas', value: 0 },
    { name: 'brandCreateEdit', text: 'Cadastrar/Editar Marca', value: 0 },
  ]
}